import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home"; // 导入Home页面
import Gallery from "./Pages/Gallery"; // 导入Gallery页面
import ContactUs from "./Pages/ContactUs"; // 导入ContactUs页面
import Terms from './Pages/Terms';
import Privacy from './Pages/Privacy';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </Router>
  );
}

export default App;